export enum ModuleType {
    RECURRING = "RECURRING",
    SINGLE = "SINGLE"
}
